// polyfill for IntersectionObserver
import 'intersection-observer/intersection-observer'
import Vue from 'vue'

import constants from '@/helpers/constants'
import App from '@/App'

// Vue router
import router from '@/router'
// Vuex
import store from '@/store/store'
// Service-worker (пока не настроен)
import '@/registerServiceWorker'
import { GoogleEnhancedEcommerce, RtbHouseService } from '@/services/AnalyticService'
// Регистрация глобальных компонентов
import '@/registerGlobalComponents'
// Плагины
import '@/plugins'
// Сервисы
import { setupServices } from '@/services'

if (process.env.NODE_ENV === 'development') {
  require('@/styles/styles-critical.sass')
  require('@/styles/styles.sass')
}

Vue.prototype.$constants = constants
window.getGaClientId = () => GoogleEnhancedEcommerce.getGaClientId()
window.getGaSessionId = () => GoogleEnhancedEcommerce.getGaSessionId()

// Настройка сервисов
setupServices()

Vue.config.devtools = window.config?.['vue_debug_enabled']

router.beforeEach(async (to, from, next) => {
  try {
    await store.dispatch('microdata/INITIALIZE_MICRODATA')// Викликаємо Vuex action що додає скрипт з мікророзміткою
    next() // Продовжуємо навігацію
  } catch (error) {
    next() // Навіть у разі помилки переходимо далі
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// eslint-disable-next-line no-unused-vars
const cartBlock = new Vue({
  el: '#vueCart',
  store
})

// eslint-disable-next-line no-unused-vars
const main = new Vue({
  el: '#main',
  store
})

// eslint-disable-next-line no-unused-vars
const header = new Vue({
  el: '#header',
  store
})

// eslint-disable-next-line no-unused-vars
const footer = new Vue({
  el: '#footer',
  store
})

// eslint-disable-next-line no-unused-vars
const vueContainer = new Vue({
  el: '#vueContainer',
  store
})

// eslint-disable-next-line no-unused-vars
const vueModalContainer = new Vue({
  el: '#vueModalContainer',
  store
})

// eslint-disable-next-line no-unused-vars
const blogContainer = new Vue({
  el: '#blogContainer',
  store
})

// eslint-disable-next-line no-unused-vars
const vuePages = new Vue({
  el: '#vuePages',
  store
})

// eslint-disable-next-line no-unused-vars
const customPages = new Vue({
  el: '#customPages',
  store,
  created () {
    if (window.location.pathname.includes('/outlet/') || window.location.pathname.includes('/sale/')) {
      RtbHouseService.SaleOrPromoCode()
    } else {
      RtbHouseService.OtherPages()
    }
  }
})
